export default "__VITE_ASSET__CUAgxvRm__"